import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import api from "../lib/api";
import { EditableText } from "./live/Editable";

export default function NewsHighlights() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const cards = items.slice(0, 3);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <EditableText path="home.news.kicker" as="p" className="kicker mb-3">
            Latest Updates
          </EditableText>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B2A6B]">
            <EditableText path="home.news.heading" as="span">
              What's happening at Kiki
            </EditableText>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {cards.map((n, i) => (
            <Link
              key={n.id}
              to="/news"
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-slate-100 tilt-card animate-fade-up"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={n.image_url} alt={n.title} className="absolute inset-0 w-full h-full object-cover zoom-img" />
                <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-yellow-400 text-[#0B2A6B] text-xs font-bold inline-flex items-center gap-1">
                  <Calendar className="h-3 w-3" />
                  {new Date(n.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-[#0B2A6B] text-lg leading-snug group-hover:text-yellow-600 transition mb-2">
                  {n.title}
                </h3>
                <p className="text-sm text-slate-600 line-clamp-2 mb-3">{n.excerpt}</p>
                <span className="text-yellow-600 font-bold text-sm inline-flex items-center gap-1 group-hover:translate-x-1 transition">
                  Read More <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
